import { render, staticRenderFns } from "./EditAdminDisabled.vue?vue&type=template&id=49daf286&scoped=true&"
import script from "./EditAdminDisabled.vue?vue&type=script&lang=js&"
export * from "./EditAdminDisabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49daf286",
  null
  
)

export default component.exports